import { render, staticRenderFns } from "./stepItem.vue?vue&type=template&id=afa51b50&scoped=true&"
import script from "./stepItem.vue?vue&type=script&lang=js&"
export * from "./stepItem.vue?vue&type=script&lang=js&"
import style0 from "./stepItem.vue?vue&type=style&index=0&id=afa51b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa51b50",
  null
  
)

export default component.exports